<template>
  <div class="chart-card">
    <div class="chart-card__header">
      <h2>{{ title }}</h2>
      <el-dropdown>
        <span class="el-dropdown-link">
          {{ $t(`message.${selected_item}`)
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in dateItems"
            @click.native="selected_item = item"
            :key="item"
            >{{ $t(`message.${item}`) }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="chart-card__statistic">
      <div
        class="chart-card__statistic-item"
        v-for="(item, index) in statistic"
        :key="index"
      >
        <h3 class="count">{{ item.count }}</h3>
        <p class="subtitle">{{ item.subtitle }}</p>
      </div>
    </div>
    <div>
      <apexchart
        type="area"
        ref="chart"
        height="300"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["chart", "title"],
  data() {
    return {
      statistic: [],
      series: [],
      selected_item: "daily",
      dateItems: [
        "daily",
        "weekly",
        "monthly",
        "quarterly",
        "half_yearly",
        "yearly",
      ],
      chartOptions: {
        theme: {
          mode: "light",
        },
        chart: {
          background: "transparent",
          height: 350,
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          position: "top",
        },
        stroke: {
          width: 2,
          curve: "smooth",
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
        colors: ["#e6dd63", "#0ea5e9","#7feb71","#e20aff"],
      },
    };
  },
  watch: {
    chart: function (val) {
      this.setData(val, this.selected_item);
    },
    selected_item: function (val) {
      this.setData(this.chart, val);
    },
    mode(bool) {
      this.updateChart(bool);
    },
  },
  mounted() {
    this.updateChart(this.mode);
  },
  methods: {
    setData(val, selected_item) {
      const chart = this.$refs.chart;
      this.chartOptions.xaxis.categories = [];
      this.series = [];
      for (const key in val) {
        const element = val[key];

        let name = this.paymentTypes.find((paymentTypesitem) => {
          return paymentTypesitem.id == key;
        })
          ? this.paymentTypes.find((paymentTypesitem) => {
              return paymentTypesitem.id == key;
            }).name
          : $t("message.totaly");

        this.series.push({
          name: name,
          data: element[selected_item].map((item) => parseFloat(item.summ)),
        });
        chart.updateOptions({
          xaxis: {
            categories: element[selected_item].map((item) => item.data),
          },
        });
        // if (!this.chartOptions.xaxis.categories.length) {
        //   element[selected_item]
        //     .map((item) => item.data)
        //     .forEach((element) => {
        //       console.log(element);
        //       this.chartOptions.xaxis.categories.push(element);
        //     });
        // }
      }
    },
    updateChart(bool) {
      this.$refs.chart.updateOptions({
        theme: {
          mode: bool ? "dark" : "light",
        },
      });
    },
  },

  computed: {
    ...mapGetters({
      paymentTypes: "paymentTypes/list",
      mode: "theme/MODE",
    }),
  },
};
</script>

<style lang="scss" scoped>
.chart-card {
  // chart-card__statistic
  &__statistic {
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    // chart-card__statistic-item
    &-item {
      .count {
        font-size: 20px;
        font-weight: 600;
        margin: 0;
        position: relative;
      }

      .subtitle {
        color: #9ca3af;
        font-size: 13px;
        margin: 0;
      }

      &:nth-child(2) .count::before,
      &:last-child .count::before {
        content: "";
        position: absolute;
        top: 50%;
        left: -14px;
        transform: translateY(-50%);
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #8b5cf6;
      }

      &:last-child .count::before {
        background: #0ea5e9;
      }
    }
  }
}
</style>

<style lang="scss">
.chart-card__header .el-dropdown-link {
  margin: 0;
  border: none;
}
</style>